import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cx } from './cx';

const inputBase =
  'w-full bg-paper border border-rule-strong rounded-none px-3 py-2 text-sm text-ink ' +
  'placeholder:text-muted-2 outline-none transition-colors ' +
  'focus:border-ink focus:bg-linen disabled:opacity-50';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cx(inputBase, className)} {...rest} />;
  },
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, ...rest }, ref) {
    return <textarea ref={ref} className={cx(inputBase, 'min-h-[6rem]', className)} {...rest} />;
  },
);
